var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.countryData, function (item, sectionIndex) {
      return _c(
        "Accordion",
        {
          key: sectionIndex,
          attrs: { full: true, "dir-button": true, title: item.title },
        },
        [
          _c(
            "el-tabs",
            { staticClass: "report-tabs" },
            _vm._l(item.jurisdictions, function (tab, index) {
              return _c(
                "el-tab-pane",
                {
                  key: index,
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "country__icon" }, [
                              tab.iso
                                ? _c("img", {
                                    attrs: {
                                      src: require(`../../assets/images/flags/${tab.iso.toLowerCase()}.svg`),
                                      alt: tab.name,
                                    },
                                  })
                                : _c("img", {
                                    attrs: {
                                      src: require("../../assets/icons/i_turkey.svg"),
                                      alt: "",
                                    },
                                  }),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(tab.name))]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm._v(" "),
                  _vm._l(tab.paragraphs, function (paragraph, paraIndex) {
                    return _c("div", {
                      key: paraIndex,
                      domProps: { innerHTML: _vm._s(paragraph) },
                    })
                  }),
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }